"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Fitxer: LoadState
 * Autor: Jordi Riu Amblàs
 * Data: 10/04/2018
 * (c) Ajuntament de Manresa - abr 2018 - Departament de Sistemes d'Informació
 */

var mobx_1 = require("mobx");

var LoadState =
/** @class */
function () {
  function LoadState(appState) {
    // Milisegons que espera el programa abans de cridar a la funció isLoadingFunction
    this.isLoadingTimeOut = 1000;
    this.countLoading = 0;
    this.isLoading = false;
    this.isLoadingTimeOut = appState.config.progressLoadingTimeOut || this.isLoadingTimeOut;
  }

  LoadState.prototype.resetLoading = function () {
    this.countLoading = 0;
    this.isLoading = false;
  };

  LoadState.prototype.setIsLoading = function (bLoading) {
    var _this = this; // Si comencem una crida


    if (bLoading) {
      this.countLoading++;
      setTimeout(function () {
        if (_this.countLoading) {
          _this.isLoading = true;
        }
      }, this.isLoadingTimeOut); // Si acabem una crida
    } else {
      if (this.countLoading) {
        this.countLoading--;
      }

      if (!this.countLoading) {
        this.isLoading = false;
      }
    }
  };

  __decorate([mobx_1.observable], LoadState.prototype, "countLoading", void 0);

  __decorate([mobx_1.observable], LoadState.prototype, "isLoading", void 0);

  __decorate([mobx_1.action], LoadState.prototype, "resetLoading", null);

  __decorate([mobx_1.action], LoadState.prototype, "setIsLoading", null);

  return LoadState;
}();

exports.default = LoadState;